import {CourtSide} from "./court-info.type";

export const ServiceOutcome = {
  Ace: 'Ace',
  Error: 'Error',
  Received: 'Received'
} as const
export type ServiceOutcome = typeof ServiceOutcome[keyof typeof ServiceOutcome]

export const ServePlayerRelativeLocation = {
  Left: 'Left',
  Right: 'Right',
  Middle: 'Middle',
} as const
export type ServePlayerRelativeLocation = typeof ServePlayerRelativeLocation[keyof typeof ServePlayerRelativeLocation]

export const ServeOutLocation = {
  WideLeftShallow: 'WideLeftShallow',
  WideLeftDeep: 'WideLeftDeep',
  WideRightShallow: 'WideRightShallow',
  WideRightDeep: 'WideRightDeep',
  DeepLeft: 'DeepLeft',
  DeepRight: 'DeepRight',
  Net: 'Net',
  Fault: 'Fault'
} as const
export type ServeOutLocation = typeof ServeOutLocation[keyof typeof ServeOutLocation]

export interface ServeInPlayLocation {
  side: CourtSide;
  playerRelativeLocation: ServePlayerRelativeLocation;
}
export const serveInPlayLocationMatches = (location1?: ServeInPlayLocation, location2?: ServeInPlayLocation): boolean => {
  if(!location1 && !location2) return true;
  if(!location1 || !location2) return false;
  return location1.side === location2.side && location1.playerRelativeLocation === location2.playerRelativeLocation;
}

export type AceServe = {
  outcome: 'Ace';
  inPlayLocation: ServeInPlayLocation;
  receivingPlayerId: number;
}
export type ReceivedServe = {
  outcome: 'Received';
  inPlayLocation: ServeInPlayLocation;
  receivingPlayerId: number;
}
export type ErrorServe = {
  outcome: 'Error';
  outLocation: ServeOutLocation;
}
export type ServeInfo = AceServe | ReceivedServe | ErrorServe;

export const isErrorServe = (serve: ServeInfo): serve is ErrorServe => {
  return serve.outcome === 'Error';
}

export const isAceServe = (serve: ServeInfo): serve is AceServe => {
  return serve.outcome === 'Ace';
}

export const isInPlayServe = (serve: ServeInfo): serve is ReceivedServe => {
  return serve.outcome === 'Received';
}

